import { render, staticRenderFns } from "./notifice.vue?vue&type=template&id=7984266e&scoped=true&"
import script from "./notifice.vue?vue&type=script&lang=ts&"
export * from "./notifice.vue?vue&type=script&lang=ts&"
import style0 from "./notifice.vue?vue&type=style&index=0&id=7984266e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984266e",
  null
  
)

component.options.__file = "notifice.vue"
export default component.exports